import RestService from './RestService'

export default class IntegrationsService extends RestService {
    constructor() {
        super('integrations')
    }

    listByApp(appId) {
        let url = this.baseUrl + '/api/v1/' + this.modelPath + '.json?t=' + Date.now() + '&id=' + appId
        return this.executeGet(url)
    }

    executeCommand(integrationId, data) {
        let url = this.baseUrl + '/api/v1/integration-service/' + integrationId + '.json?t=' + Date.now()
        return new Promise((resolve, reject) => {
            this.http.post(url)
                .send(data)
                .set('x-api-token', this.authToken)
                .set('Accept', 'application/json')
                .end((error, response) => {
                    if (response.status === 200 || response.status === 201) {
                        resolve(JSON.parse(response.text))
                    } else {
                        reject(JSON.parse(response.text))
                    }
                })
        })
    }
}